import { FC } from 'react';
import { Control, UseFormHandleSubmit } from 'react-hook-form';
import { Button } from 'atoms/Button';
import { Link } from 'atoms/Link/Link';
import { Password } from 'organisms/Password';
import { TextInput } from 'organisms/TextInput';
import { useTranslations } from 'modules/i18n/useTranslations';
import { AppRoutes } from 'modules/shop/routes';
import { LoginCredentials } from 'commerce/scayle/auth/types';
import styles from './styles.module.css';

export const BaseLoginForm: FC<{
  onSubmit: ReturnType<UseFormHandleSubmit<LoginCredentials>>;
  control: Control<LoginCredentials>;
}> = ({ onSubmit, control }) => {
  const t = useTranslations();

  return (
    <form className={styles.form} onSubmit={onSubmit}>
      <div className={styles.fields}>
        <TextInput
          control={control}
          name="email"
          placeholder={t('common.placeholders.email')}
        />
        <Password control={control} />
      </div>

      <Button type="submit">{t('common.buttons.submit')}</Button>
      <Link href={AppRoutes.RESET_PASSWORD} className={styles.forgotPassword}>
        {t('login.popup.forgot-password')}
      </Link>
    </form>
  );
};
